function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsClose, vsArrowUp, vsArrowDown } from '@deephaven/icons';
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Type as FilterType } from '@deephaven/filters';
import { Button, DateTimeInput, Select } from '@deephaven/components';
import { TableUtils } from '@deephaven/jsapi-utils';
import classNames from 'classnames';
import "./GotoRow.css";
import { nanoid } from 'nanoid';
import IrisGridBottomBar from "./IrisGridBottomBar.js";
import { isIrisGridTableModelTemplate } from "./IrisGridTableModelTemplate.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var DEFAULT_FORMAT_STRING = '###,##0';
var GotoRow = /*#__PURE__*/forwardRef((_ref, ref) => {
  var gotoRow = _ref.gotoRow,
    gotoRowError = _ref.gotoRowError,
    gotoValueError = _ref.gotoValueError,
    onGotoRowSubmit = _ref.onGotoRowSubmit,
    isShown = _ref.isShown,
    onEntering = _ref.onEntering,
    _onEntered = _ref.onEntered,
    onExiting = _ref.onExiting,
    onExited = _ref.onExited,
    model = _ref.model,
    onGotoRowNumberChanged = _ref.onGotoRowNumberChanged,
    onClose = _ref.onClose,
    gotoValueSelectedColumnName = _ref.gotoValueSelectedColumnName,
    gotoValue = _ref.gotoValue,
    gotoValueFilter = _ref.gotoValueFilter,
    onGotoValueSelectedColumnNameChanged = _ref.onGotoValueSelectedColumnNameChanged,
    onGotoValueSelectedFilterChanged = _ref.onGotoValueSelectedFilterChanged,
    onGotoValueChanged = _ref.onGotoValueChanged,
    onGotoValueSubmit = _ref.onGotoValueSubmit;
  var gotoRowInputRef = useRef(null);
  var gotoValueInputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGotoRowActive = _useState2[0],
    setIsGotoRowActive = _useState2[1];
  var columns = [];
  if (isIrisGridTableModelTemplate(model)) {
    columns = model.table.columns;
  }
  var dh = model.dh,
    rowCount = model.rowCount;
  var gotoRowInputId = useMemo(() => "goto-row-input-".concat(nanoid()), []);
  var handleGotoValueNumberKeyDown = e => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      onGotoValueSubmit();
    } else if ((e.key === 'Backspace' || e.key === 'Delete') && (gotoValue === "".concat(Number.POSITIVE_INFINITY) || gotoValue === "".concat(Number.NEGATIVE_INFINITY))) {
      onGotoValueInputChanged('');
    }
  };
  var handleGotoValueKeySubmit = e => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      onGotoValueSubmit(e.shiftKey);
    }
  };
  var index = model.getColumnIndexByName(gotoValueSelectedColumnName);
  var selectedColumn = columns[index !== null && index !== void 0 ? index : 0];
  var columnType = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.type;
  var normalizedType = TableUtils.getNormalizedType(columnType);
  var onGotoValueInputChanged = value => {
    onGotoValueChanged(value !== null && value !== void 0 ? value : '');
  };
  useImperativeHandle(ref, () => ({
    focus() {
      var _gotoRowInputRef$curr;
      setIsGotoRowActive(true);
      (_gotoRowInputRef$curr = gotoRowInputRef.current) === null || _gotoRowInputRef$curr === void 0 || _gotoRowInputRef$curr.select();
    }
  }));
  var selectInput = () => {
    // when row changes without focus (i.e. via context menu), re-select input
    if (isGotoRowActive && document.activeElement !== gotoRowInputRef.current) {
      var _gotoRowInputRef$curr2;
      (_gotoRowInputRef$curr2 = gotoRowInputRef.current) === null || _gotoRowInputRef$curr2 === void 0 || _gotoRowInputRef$curr2.select();
    } else if (!isGotoRowActive && document.activeElement !== gotoValueInputRef.current) {
      var _gotoValueInputRef$cu;
      (_gotoValueInputRef$cu = gotoValueInputRef.current) === null || _gotoValueInputRef$cu === void 0 || _gotoValueInputRef$cu.select();
    }
  };
  useEffect(selectInput, [isGotoRowActive]);
  var renderValueInput = () => {
    switch (normalizedType) {
      case TableUtils.dataType.DECIMAL:
      case TableUtils.dataType.INT:
        return /*#__PURE__*/_jsx("div", {
          className: "goto-row-input",
          children: /*#__PURE__*/_jsx("input", {
            ref: gotoValueInputRef,
            className: classNames('form-control', {
              'is-invalid': gotoValueError !== ''
            }),
            onKeyDown: handleGotoValueNumberKeyDown,
            placeholder: "value",
            onChange: e => {
              var value = e.target.value.toLowerCase();
              // regex tests for
              if (/^-?[0-9]*\.?[0-9]*$/.test(e.target.value)) {
                onGotoValueInputChanged(e.target.value);
              } else if (value === '-i' || value === '-infinity') {
                onGotoValueInputChanged("".concat(Number.NEGATIVE_INFINITY));
              } else if (value === 'i' || value === 'infinity') {
                onGotoValueInputChanged("".concat(Number.POSITIVE_INFINITY));
              }
            },
            value: gotoValue,
            "aria-label": "Value Input"
          })
        });
      case TableUtils.dataType.DATETIME:
        return /*#__PURE__*/_jsx("div", {
          className: "goto-value-date-time-input",
          children: /*#__PURE__*/_jsx(DateTimeInput, {
            ref: gotoValueInputRef,
            className: classNames('form-control', 'goto-value-date-time-input', {
              'is-invalid': gotoValueError !== ''
            }),
            defaultValue: gotoValue,
            onChange: onGotoValueInputChanged,
            onSubmit: handleGotoValueKeySubmit,
            "aria-label": "Value Input"
          })
        });
      case TableUtils.dataType.STRING:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "goto-row-input",
            children: /*#__PURE__*/_jsxs(Select, {
              className: "custom-select",
              onChange: eventTargetValue => {
                onGotoValueSelectedFilterChanged(eventTargetValue);
              },
              value: gotoValueFilter,
              "aria-label": "filter-type-select",
              children: [/*#__PURE__*/_jsx("option", {
                value: FilterType.eqIgnoreCase,
                children: "Equals (case-insensitive)"
              }, FilterType.eqIgnoreCase), /*#__PURE__*/_jsx("option", {
                value: FilterType.containsIgnoreCase,
                children: "Contains (case-insensitive)"
              }, FilterType.containsIgnoreCase), /*#__PURE__*/_jsx("option", {
                value: FilterType.eq,
                children: "Equals"
              }, FilterType.eq), /*#__PURE__*/_jsx("option", {
                value: FilterType.contains,
                children: "Contains"
              }, FilterType.contains)]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "goto-row-input",
            children: /*#__PURE__*/_jsx("input", {
              ref: gotoValueInputRef,
              className: classNames('form-control', {
                'is-invalid': gotoValueError !== ''
              }),
              onKeyDown: handleGotoValueKeySubmit,
              placeholder: "value",
              onChange: e => onGotoValueInputChanged(e.target.value),
              value: gotoValue,
              "aria-label": "Value Input"
            })
          })]
        });
      case TableUtils.dataType.BOOLEAN:
        return /*#__PURE__*/_jsx("div", {
          className: "goto-row-input",
          children: /*#__PURE__*/_jsxs(Select, {
            className: "custom-select",
            onChange: eventTargetValue => {
              onGotoValueInputChanged(eventTargetValue);
            },
            value: gotoValue,
            "aria-label": "Value Input",
            children: [/*#__PURE__*/_jsx("option", {
              "aria-label": "null value",
              value: ""
            }, "null"), /*#__PURE__*/_jsx("option", {
              value: "true",
              children: "true"
            }, "true"), /*#__PURE__*/_jsx("option", {
              value: "false",
              children: "false"
            }, "false")]
          })
        });
      default:
        return /*#__PURE__*/_jsx("div", {
          className: "goto-row-input",
          children: /*#__PURE__*/_jsx("input", {
            ref: gotoValueInputRef,
            className: "form-control",
            onKeyDown: handleGotoValueKeySubmit,
            placeholder: "value",
            onChange: e => onGotoValueInputChanged(e.target.value),
            value: gotoValue,
            "aria-label": "Value Input"
          })
        });
    }
  };
  return /*#__PURE__*/_jsx(IrisGridBottomBar, {
    isShown: isShown,
    className: classNames('goto-row'),
    onEntering: onEntering,
    onEntered: () => {
      _onEntered();
      selectInput();
    },
    onExiting: onExiting,
    onExited: onExited,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "goto-row-row",
        children: [/*#__PURE__*/_jsxs("div", {
          className: classNames('goto-row-wrapper', {
            'is-inactive': !isGotoRowActive
          }),
          onClick: () => setIsGotoRowActive(true),
          onFocus: () => setIsGotoRowActive(true),
          role: "group",
          children: [/*#__PURE__*/_jsx("label", {
            className: "goto-row-text",
            htmlFor: gotoRowInputId,
            children: "Go to row"
          }), /*#__PURE__*/_jsx("div", {
            className: "goto-row-input",
            children: /*#__PURE__*/_jsx("input", {
              ref: gotoRowInputRef,
              "data-testid": "goto-row-input",
              type: "number",
              onKeyDown: e => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                  e.preventDefault();
                  onGotoRowSubmit();
                }
              },
              className: classNames('form-control', {
                'is-invalid': gotoRowError !== ''
              }),
              placeholder: "Row number",
              onChange: event => {
                onGotoRowNumberChanged(event);
              },
              value: gotoRow,
              id: gotoRowInputId
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "goto-row-text",
            children: ["of", ' ', dh.i18n.NumberFormat.format(DEFAULT_FORMAT_STRING, rowCount)]
          }), gotoRowError && /*#__PURE__*/_jsx("div", {
            className: "text-danger",
            children: gotoRowError
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "goto-row-close",
          children: /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsClose,
              style: {
                marginRight: '0'
              }
            })
          })
        })]
      }), model.isSeekRowAvailable && /*#__PURE__*/_jsx("div", {
        className: "goto-row-row",
        children: /*#__PURE__*/_jsxs("div", {
          className: classNames('goto-row-wrapper', {
            'is-inactive': isGotoRowActive
          }),
          onClick: () => setIsGotoRowActive(false),
          onFocus: () => setIsGotoRowActive(false),
          role: "group",
          children: [/*#__PURE__*/_jsx("div", {
            className: "goto-row-text",
            children: "Go to value"
          }), /*#__PURE__*/_jsx("div", {
            className: "goto-row-input",
            children: /*#__PURE__*/_jsx(Select, {
              className: "custom-select",
              onChange: eventTargetValue => {
                var columnName = eventTargetValue;
                onGotoValueSelectedColumnNameChanged(columnName);
              },
              value: gotoValueSelectedColumnName,
              "aria-label": "column-name-select",
              id: "column-name-select",
              children: columns.map(column => /*#__PURE__*/_jsx("option", {
                value: column.name,
                children: column.name
              }, column.name))
            })
          }), renderValueInput(), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Button, {
              tooltip: "Previous match",
              icon: vsArrowUp,
              kind: "ghost",
              disabled: gotoValue === '',
              onClick: () => {
                onGotoValueSubmit(true);
              }
            }), /*#__PURE__*/_jsx(Button, {
              tooltip: "Next match",
              icon: vsArrowDown,
              kind: "ghost",
              disabled: gotoValue === '',
              onClick: () => {
                onGotoValueSubmit(false);
              }
            })]
          }), gotoValueError && /*#__PURE__*/_jsx("div", {
            className: "text-danger",
            children: gotoValueError
          })]
        })
      })]
    })
  });
});
GotoRow.displayName = 'GotoRow';
export default GotoRow;
//# sourceMappingURL=GotoRow.js.map